import styled from 'styled-components';

// Shared Types

// Shared Constants
export var DROPDOWN_MENU_DEFAULTS = {
  menuAnchor: 'left',
  menuWidth: 'auto',
  size: 'medium'
};
export var DROPDOWN_CHOICE_LIST_ATTR = 'data-dropdown-choice-list';

// Base Props Interface

// Base Styled Props

// Base Styled Wrapper - can be extended by both components
export var BaseStyledWrapper = styled.div.withConfig({
  componentId: "CL__sc-ex2yld-0"
})(["background-color:var(--surface-bkg-color);border-radius:var(--border-radius-medium);box-shadow:var(--box-shadow-dropdown);color:var(--text-color);height:auto;position:absolute;width:", ";", ""], _ref => {
  var {
    $menuWidth
  } = _ref;
  return $menuWidth;
}, _ref2 => {
  var {
    $menuAnchor
  } = _ref2;
  return $menuAnchor === 'left' ? 'left: 0;' : 'right: 0;';
});